<template>
    <div id="product_edit_modal" class="ui middle aligned center aligned grid" v-if="showModal">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">{{ isEditMode ? "상품 정보" : "상품 추가" }}</h3>
            </div>
            <div id="body" class="ui segment">
                <div class="ui form">
                    <div class="two fields">
                        <div class="field">
                            <div class="ui fluid image">
                                <img :src="imageUrl ? imageUrl : 'https://fomantic-ui.com/images/wireframe/image.png'" @click="onImageClick">
                                <input hidden ref="image" accept="image/*" type="file" id="file" name="image" @change="onImageChange"/>
                            </div>
                        </div>
                        <div class="field">
                            <label class="ui left aligned header">업체</label>
                            <select v-model="_partnerId" class="ui simple dropdown" :disabled="isEditMode">
                                <option v-for="p in partners" :key="p._id" :value="p._id">{{ p.name }}</option>
                            </select>
                            <br>
                            <div class="field">
                                <label class="ui left aligned header">상품명</label>
                                <input type="text" placeholder="상품명을 입력하세요" v-model="name" autocomplete=off>
                                <p class="ui pointing blow orange basic label" v-if="$validator.hasError('id')">{{ $validator.getError('id') }}</p>
                            </div>
                            <br>
                            <div class="field">
                                <label class="ui left aligned header">상품코드</label>
                                <input type="text" placeholder="상품코드를 입력하세요" v-model="code" autocomplete=off>
                            </div>
                            <br>
                            <div class="field">
                                <label class="ui left aligned header">규격</label>
                                <input type="text" placeholder="규격을 입력하세요" v-model="description" autocomplete=off>
                            </div>
                            <div class="field" v-if="isEditMode">
                                <div class="ui checkbox">
                                    <input type="checkbox" v-model="product.isTerminated">
                                    <label>판매종료</label>
                                </div>
                            </div>
                            <div class="field" v-if="isEditMode && certificated">
                                <div class="ui checkbox">
                                    <input type="checkbox" v-model="product.normalCalculate" @change="setChanged">
                                    <label>일반정산</label>
                                </div>
                                <div class="ui checkbox">
                                    <input type="checkbox" v-model="product.parcelCalculate" @change="setChanged">
                                    <label>택배정산</label>
                                </div>
                                <div class="ui checkbox">
                                    <input type="checkbox" v-model="product.centerCalculate" @change="setChanged">
                                    <label>센터정산</label>
                                </div>
                                <div class="ui checkbox">
                                    <input type="checkbox" v-model="product.workerCalculate" @change="setChanged">
                                    <label>기사정산</label>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="field">
                            <label class="ui left aligned header">등록날짜</label>
                            <input type="text" v-model="createdAt" disabled=true>
                        </div> -->
                    </div>
                    <!-- <div class="three fields">
                        
                    </div> -->
                    <div class="field" v-if="isEditMode && certificated">
                        <label class="ui left aligned header">택배단가</label>
                        <table class="ui selectable basic compact table">
                            <thead>
                                <tr>
                                    <th>택배비</th>
                                    <th>상품비</th>
                                    <th>제주</th>
                                </tr>
                            </thead>
                            <tbody class ="ui form">
                                <tr>
                                    <td><input type="number" v-model="product.parcelPrice_default" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.parcelPrice_goods" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.parcelPrice_jeju" @change="setChanged"></td>
                                    <!-- <td><input type="number" v-model="product.parcelPrice_braket" @change="setChanged"></td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="field" v-if="isEditMode && certificated">
                        <label class="ui left aligned header">일반단가</label>
                        <table class="ui selectable basic compact table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>배송</th>
                                    <th>스탠드</th>
                                    <!-- <th>이젤스탠드</th> -->
                                    <th>벽걸이</th>
                                    <th>천장벽걸이</th>
                                    <th>회수</th>
                                    <th>교환</th>
                                    <th>상하브라켓</th>
                                    <th>상하좌우브라켓</th>
                                    <th>손잡이</th>
                                </tr>
                            </thead>
                            <tbody class ="ui form">
                                <tr>
                                    <td class="collapsing">업체(수도권)</td>
                                    <td><input type="number" v-model="product.partnerPriceCapital_default" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceCapital_stand" @change="setChanged"></td>
                                    <!-- <td><input type="number" v-model="product.partnerPriceCapital_ez" @change="setChanged"></td> -->
                                    <td><input type="number" v-model="product.partnerPriceCapital_wall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceCapital_ceiling" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceCapital_recall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceCapital_exchange" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceCapital_ud" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceCapital_udlr" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceCapital_handle" @change="setChanged"></td>
                                </tr>
                                <tr>
                                    <td class="collapsing">업체(지방)</td>
                                    <td><input type="number" v-model="product.partnerPriceLocal_default" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceLocal_stand" @change="setChanged"></td>
                                    <!-- <td><input type="number" v-model="product.partnerPriceLocal_ez" @change="setChanged"></td> -->
                                    <td><input type="number" v-model="product.partnerPriceLocal_wall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceLocal_ceiling" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceLocal_recall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceLocal_exchange" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceLocal_ud" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceLocal_udlr" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.partnerPriceLocal_handle" @change="setChanged"></td>
                                </tr>
                                <tr>
                                    <td class="collapsing">기사(수도권)</td>
                                    <td><input type="number" v-model="product.workerPriceCapital_default" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceCapital_stand" @change="setChanged"></td>
                                    <!-- <td><input type="number" v-model="product.workerPriceCapital_ez" @change="setChanged"></td> -->
                                    <td><input type="number" v-model="product.workerPriceCapital_wall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceCapital_ceiling" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceCapital_recall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceCapital_exchange" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceCapital_ud" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceCapital_udlr" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceCapital_handle" @change="setChanged"></td>
                                </tr>
                                <tr v-for="center in getCenters()" :key="center.id">
                                    <td class="collapsing">{{ center.name + "(수도권)" }}</td>
                                    <td><input type="number" v-model="product.centerCapitalPrices[center._id].default" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerCapitalPrices[center._id].stand" @change="setChanged"></td>
                                    <!-- <td><input type="number" v-model="product.centerCapitalPrices[center._id].ez" @change="setChanged"></td> -->
                                    <td><input type="number" v-model="product.centerCapitalPrices[center._id].wall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerCapitalPrices[center._id].ceiling" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerCapitalPrices[center._id].recall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerCapitalPrices[center._id].exchange" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerCapitalPrices[center._id].ud" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerCapitalPrices[center._id].udlr" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerCapitalPrices[center._id].handle" @change="setChanged"></td>
                                </tr>
                                <tr>
                                    <td class="collapsing">기사(지방)</td>
                                    <td><input type="number" v-model="product.workerPriceLocal_default" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceLocal_stand" @change="setChanged"></td>
                                    <!-- <td><input type="number" v-model="product.workerPriceLocal_ez" @change="setChanged"></td> -->
                                    <td><input type="number" v-model="product.workerPriceLocal_wall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceLocal_ceiling" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceLocal_recall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceLocal_exchange" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceLocal_ud" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceLocal_udlr" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.workerPriceLocal_handle" @change="setChanged"></td>
                                </tr>
                                <tr v-for="center in getCenters()" :key="center._id">
                                    <td class="collapsing">{{ center.name + "(지방)" }}</td>
                                    <td><input type="number" v-model="product.centerLocalPrices[center._id].default" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerLocalPrices[center._id].stand" @change="setChanged"></td>
                                    <!-- <td><input type="number" v-model="product.centerLocalPrices[center._id].ez" @change="setChanged"></td> -->
                                    <td><input type="number" v-model="product.centerLocalPrices[center._id].wall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerLocalPrices[center._id].ceiling" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerLocalPrices[center._id].recall" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerLocalPrices[center._id].exchange" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerLocalPrices[center._id].ud" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerLocalPrices[center._id].udlr" @change="setChanged"></td>
                                    <td><input type="number" v-model="product.centerLocalPrices[center._id].handle" @change="setChanged"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui form">
                    <div class="inline field">
                        <div v-if="!isEditMode && checkValidate()" class="ui primary left labeled icon button" @click="createProduct">
                            <i class="checkmark icon"></i>추가
                        </div>
                        <input v-if="isHeader && isEditMode" type="password" name="password" placeholder="정산 비밀번호" v-model="password">
                        <div v-if="isHeader && isEditMode" class="ui orange left labeled icon button" @click="save">
                            <i class="checkmark icon"></i>저장
                        </div>
                        <div class="ui button" @click="close">닫기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            showModal: 0,
            isEditMode: 0,
            _partnerId: 0,
            name: 0,
            createdAt: 0,
            code: 0,
            description: 0,
            product: 0,
            oldProduct: 0,
            onChange: 0,
            password: 0,
            certificated: 0,
            changed: 0,
            imageUrl: null,
            imageFile: null,
        }
    },
    created: function() {
        this.showModal = false;
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
        this.$event.set("newProduct", this.new);
        this.$event.set("editProduct", this.edit);
    },
    beforeDestroyed: function() {
        this.$event.clear("newProduct");
        this.$event.clear("editProduct");
    },
    methods: {
        new(_partnerId, onChange) {
            if (_partnerId) {
                this.showModal = true;
                this.isEditMode = false;
                this._partnerId = _partnerId;
                this.onChange = onChange;
                this.createdAt = new Date().format("yyyy-MM-dd");
                this.name = "";
                this.code = "";
                this.description = "";
                this.product = {};
                this.oldProduct = null;
                this.password = "";
                this.imageUrl = null;
                this.changed = false;
                this.initPrice(this.product);
            } else {
                alert("협력업체를 등록해주세요");
            }
        },
        edit(_partnerId, product, onChange)
        {
            if (_partnerId) {
                this.showModal = true;
                this.isEditMode = true;
                this._partnerId = _partnerId;
                this.createdAt = new Date(product.createdAt).format("yyyy-MM-dd");
                this.name = product.name;
                this.code = product.code;
                this.description = product.description;
                this.oldProduct = product;
                this.product = JSON.parse(JSON.stringify(product));
                this.onChange = onChange;
                this.password = "";
                this.imageUrl = product.imageUrl;
                this.changed = false;
                this.initPrice(this.product);
            } else {
                alert("협력업체를 등록해주세요");
            }
        },
        close() {
            URL.revokeObjectURL(this.imageUrl);
            this.imageUrl = null;
            this.imageFile = null;
            this.showModal = false;
        },
        initPrice(product)
        {
            if (!product.partnerPriceCapital_default) product.partnerPriceCapital_default = 0;
            if (!product.partnerPriceCapital_exchange) product.partnerPriceCapital_exchange = 0;
            if (!product.partnerPriceCapital_recall) product.partnerPriceCapital_recall = 0;
            if (!product.partnerPriceCapital_stand) product.partnerPriceCapital_stand = 0;
            if (!product.partnerPriceCapital_ez) product.partnerPriceCapital_ez = 0;
            if (!product.partnerPriceCapital_wall) product.partnerPriceCapital_wall = 0;
            if (!product.partnerPriceCapital_ceiling) product.partnerPriceCapital_ceiling = 0;
            if (!product.partnerPriceCapital_ud) product.partnerPriceCapital_ud = 0;
            if (!product.partnerPriceCapital_udlr) product.partnerPriceCapital_udlr = 0;
            if (!product.partnerPriceCapital_handle) product.partnerPriceCapital_handle = 0;

            if (!product.partnerPriceLocal_default) product.partnerPriceLocal_default = 0;
            if (!product.partnerPriceLocal_exchange) product.partnerPriceLocal_exchange = 0;
            if (!product.partnerPriceLocal_recall) product.partnerPriceLocal_recall = 0;
            if (!product.partnerPriceLocal_stand) product.partnerPriceLocal_stand = 0;
            if (!product.partnerPriceLocal_ez) product.partnerPriceLocal_ez = 0;
            if (!product.partnerPriceLocal_wall) product.partnerPriceLocal_wall = 0;
            if (!product.partnerPriceLocal_ceiling) product.partnerPriceLocal_ceiling = 0;
            if (!product.partnerPriceLocal_ud) product.partnerPriceLocal_ud = 0;
            if (!product.partnerPriceLocal_udlr) product.partnerPriceLocal_udlr = 0;
            if (!product.partnerPriceLocal_handle) product.partnerPriceLocal_handle = 0;

            if (!product.workerPriceCapital_default) product.workerPriceCapital_default = 0;
            if (!product.workerPriceCapital_exchange) product.workerPriceCapital_exchange = 0;
            if (!product.workerPriceCapital_recall) product.workerPriceCapital_recall = 0;
            if (!product.workerPriceCapital_stand) product.workerPriceCapital_stand = 0;
            if (!product.workerPriceCapital_ez) product.workerPriceCapital_ez = 0;
            if (!product.workerPriceCapital_wall) product.workerPriceCapital_wall = 0;
            if (!product.workerPriceCapital_ceiling) product.workerPriceCapital_ceiling = 0;
            if (!product.workerPriceCapital_ud) product.workerPriceCapital_ud = 0;
            if (!product.workerPriceCapital_udlr) product.workerPriceCapital_udlr = 0;
            if (!product.workerPriceCapital_handle) product.workerPriceCapital_handle = 0;

            if (!product.workerPriceLocal_default) product.workerPriceLocal_default = 0;
            if (!product.workerPriceLocal_exchange) product.workerPriceLocal_exchange = 0;
            if (!product.workerPriceLocal_recall) product.workerPriceLocal_recall = 0;
            if (!product.workerPriceLocal_stand) product.workerPriceLocal_stand = 0;
            if (!product.workerPriceLocal_ez) product.workerPriceLocal_ez = 0;
            if (!product.workerPriceLocal_wall) product.workerPriceLocal_wall = 0;
            if (!product.workerPriceLocal_ceiling) product.workerPriceLocal_ceiling = 0;
            if (!product.workerPriceLocal_ud) product.workerPriceLocal_ud = 0;
            if (!product.workerPriceLocal_udlr) product.workerPriceLocal_udlr = 0;
            if (!product.workerPriceLocal_handle) product.workerPriceLocal_handle = 0;

            for (const center of this.centers)
            {
                if (!product.centerCapitalPrices) product.centerCapitalPrices = {};
                if (!product.centerCapitalPrices[center._id]) product.centerCapitalPrices[center._id] = {};
                if (!product.centerCapitalPrices[center._id].default) product.centerCapitalPrices[center._id].default = 0;
                if (!product.centerCapitalPrices[center._id].exchange) product.centerCapitalPrices[center._id].exchange = 0;
                if (!product.centerCapitalPrices[center._id].recall) product.centerCapitalPrices[center._id].recall = 0;
                if (!product.centerCapitalPrices[center._id].stand) product.centerCapitalPrices[center._id].stand = 0;
                if (!product.centerCapitalPrices[center._id].ez) product.centerCapitalPrices[center._id].ez = 0;
                if (!product.centerCapitalPrices[center._id].wall) product.centerCapitalPrices[center._id].wall = 0;
                if (!product.centerCapitalPrices[center._id].ceiling) product.centerCapitalPrices[center._id].ceiling = 0;
                if (!product.centerCapitalPrices[center._id].ud) product.centerCapitalPrices[center._id].ud = 0;
                if (!product.centerCapitalPrices[center._id].udlr) product.centerCapitalPrices[center._id].udlr = 0;
                if (!product.centerCapitalPrices[center._id].handle) product.centerCapitalPrices[center._id].handle = 0;

                if (!product.centerLocalPrices) product.centerLocalPrices = {};
                if (!product.centerLocalPrices[center._id]) product.centerLocalPrices[center._id] = {};
                if (!product.centerLocalPrices[center._id].default) product.centerLocalPrices[center._id].default = 0;
                if (!product.centerLocalPrices[center._id].exchange) product.centerLocalPrices[center._id].exchange = 0;
                if (!product.centerLocalPrices[center._id].recall) product.centerLocalPrices[center._id].recall = 0;
                if (!product.centerLocalPrices[center._id].stand) product.centerLocalPrices[center._id].stand = 0;
                if (!product.centerLocalPrices[center._id].ez) product.centerLocalPrices[center._id].ez = 0;
                if (!product.centerLocalPrices[center._id].wall) product.centerLocalPrices[center._id].wall = 0;
                if (!product.centerLocalPrices[center._id].ceiling) product.centerLocalPrices[center._id].ceiling = 0;
                if (!product.centerLocalPrices[center._id].ud) product.centerLocalPrices[center._id].ud = 0;
                if (!product.centerLocalPrices[center._id].udlr) product.centerLocalPrices[center._id].udlr = 0;
                if (!product.centerLocalPrices[center._id].handle) product.centerLocalPrices[center._id].handle = 0;
            }

            if (!product.parcelPrice_default) product.parcelPrice_default = 0;
            if (!product.parcelPrice_goods) product.parcelPrice_goods = 0;
            if (!product.parcelPrice_jeju) product.parcelPrice_jeju = 0;
        },
        createProduct() {
            if (this.checkValidate()) {
                const newProduct = { name: this.name, code: this.code, description: this.description, }
                this.$event.call("openLoading");
                this.$api.addProduct(this._partnerId, newProduct, (resData) => {
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        if (this.imageFile && resData.product) {
                            this.$api.uploadProductImage(resData.product._id, this.imageFile, res => {
                                this.$event.call("closeLoading");
                                this.close();
                                if (this.onChange) this.onChange(); 
                            });
                        }
                        else{
                            this.$event.call("closeLoading");
                            this.close();
                            if (this.onChange) this.onChange(); 
                        }
                    }
                });
            }
        },
        save()
        {
            if (this.changed)
            {
                if (!this.certificated)
                {
                    alert("비밀번호를 입력하세요!");
                    return;
                }
            }

            this.$event.call("openLoading");
            this.$api.modifyProduct(this.product, (resData) =>
            {
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    if (this.imageFile){
                        this.$api.uploadProductImage(this.product._id, this.imageFile, res => {
                            this.$event.call("closeLoading");
                            if (res.error) {
                                alert(res.error.message);
                            }
                            else {
                                this.close();
                                if (this.onChange) this.onChange(); 
                            }
                        });
                    }
                    else{
                        this.$event.call("closeLoading");
                        this.close();
                        if (this.onChange) this.onChange(); 
                    }
                }
            });
        },
        checkValidate() {
            this.$validator.clear();
            this.$validator.checkEmpty("name", this.name);
            return this.$validator.isAllValidate();
        },
        setChanged() {
            this.changed = true;
        },
        onImageClick() {
            this.$refs['image'].click();
        },
        onImageChange(e) {
            if (e.target.files.length > 0)
            {
                this.imageFile = e.target.files[0];
            }
        },
        getCenters()
        {
            const array = [];
            for (const center of this.centers)
            {
                if (!center.isTerminated) array.push(center);
            }
            return array;
        },
    },
    computed: {
        ownerPassword: function() { return this.$store.getters.ownerPassword; },
        partners: function() { return this.$store.getters.partners; },
        centers: function() { return this.$store.getters.centers; },
        isHeader: function() { return this.$store.getters.isHeader; },
        isPartner: function() { return this.$store.getters.isPartner; },
        products: {
            get: function() { return this.$store.getters.products; },
            set: function(products) { this.$store.commit("setProducts", products); },
        },
    },
    watch: {
        name: function(val) {
            this.name = this.$validator.replaceAlphaKorNumSpecial(val).toUpperCase().substring(0, 30);
            this.product.name = this.name;
            this.checkValidate();
        },
        code: function(val) {
            this.code = (val) ? val.replace(/[\s]/g, "") : "";
            this.product.code = this.code;
        },
        description: function(val) {
            this.description = (val) ? val.replace(/[\s]/g, "") : "";
            this.product.description = this.description;
        },
        password: function(val) {
            this.certificated = (val == this.ownerPassword);
        }
    },
}
</script>

<style>

#product_edit_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#product_edit_modal .column {
    max-width: 1400px;
}

#product_edit_modal #header {
    padding: 20px 30px;
}

#product_edit_modal #body {
    padding: 0;
}

#product_edit_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#product_edit_modal #footer .ui.form {
    padding: 0;
}

#product_edit_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductModal_Edit.vue